// Voice is on by default in every Community world (Pieter, 2026-10-10: "if we turned voice on by
// default it could be easy to dive into the experience"). Arriving asks for the microphone and
// joins the people near you; if the mic is refused or missing you still hear them. Turning voice
// off is remembered on this device, and from then on you arrive quiet until you turn it on again.
// The camera is never automatic - it stays one click away.
const KEY = "jane.community.voice"

export function voiceWanted() {
    try { return window.localStorage.getItem(KEY) !== "off" } catch (_e) { return true }
}

export function rememberVoice(on) {
    try { window.localStorage.setItem(KEY, on ? "on" : "off") } catch (_e) { /* private mode */ }
}

// Join voice as the world opens (call it once the server's `hello` gave us a peer id). Resolves to
// "talking", "listening" or null (voice off by choice, or no audio at all).
export async function joinByDefault(voice) {
    if (!voiceWanted() || voice.enabled) return null
    try {
        await voice.enable()
        return "talking"
    } catch (_e) {
        try { await voice.listen(); return "listening" } catch (_e2) { return null }
    }
}
